import pluralize from "pluralize";
function TabbedTable(props) {
  const getFakeLoady = (num, columns) =>
    Array.from(Array(num).keys()).map((i) => (
      <tr key={`tr${i}`}>
        {Array.from(Array(columns.length).keys()).map((j) => (
          <td key={`td${j}`}>
            <div className="skeleton rounded"></div>
          </td>
        ))}
      </tr>
    ));

  const type = props.type || "Result";

  return (
    <>
      <ul
        className="nav nav-pills mb-3 mt-4 bg-white p-2 rounded"
        role="tablist"
      >
        {props.tabs.map((tab, index) => {
          const selected = tab.label === props.selectedTab.label;
          return (
            <li key={`status${index}`} className="nav-item" role="presentation">
              <button
                onClick={props.onTabClick(tab)}
                className={`nav-link ${selected ? "active bg-primary" : ""}`}
                id={`pills-tab-${index}`}
                data-bs-toggle="pill"
                data-bs-target={`#pills-${index}`}
                type="button"
                role="tab"
                aria-controls={`#pills-${index}`}
                aria-selected="true"
              >
                {tab.label}
                {props.disableCounts ? null : (
                  <span
                    className={`badge bg-${
                      selected ? "light" : tab.color
                    } ms-2`}
                  >
                    {props.getTabBadgeCount?.(tab) || 0}
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
      <div className="tab-content" id="pills-tabContent">
        {props.tabs.map((tab, index) => {
          const defaultType = tab.type || type;
          return (
            <div
              key={`tabContent${index}`}
              className={`tab-pane fade show ${
                tab.label === props.selectedTab.label ? "active" : ""
              }`}
              id={`#pills-${index}`}
              role="tabpanel"
              aria-labelledby={`pills-tab-${index}`}
            >
              <div className="card">
                <div className="card-header">
                  <div className="card-title">{tab.title}</div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <div className="table-responsive">
                      <table className="table products-table">
                        <thead>
                          <tr>
                            {tab.columns.map((column) => (
                              <th key={column.label}>{column.label}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {props.data === null && getFakeLoady(3, tab.columns)}

                          {props.data?.map((item, index) =>
                            props.rowIsLoading?.(item) ? (
                              getFakeLoady(1, tab.columns)
                            ) : (
                              <tr key={`${defaultType}${index}`}>
                                {tab.columns.map((column, j) => (
                                  <td
                                    key={`${defaultType}-row-${index}-column-${j}`}
                                  >
                                    {column.value(item)}
                                  </td>
                                ))}
                              </tr>
                            )
                          )}

                          {props.data?.length === 0 && (
                            <tr>
                              <td
                                colSpan={12}
                                style={{
                                  textAlign: "center",
                                  fontSize: "14px",
                                }}
                              >
                                No {pluralize(defaultType).toLowerCase()} to
                                show
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      {props.showLoadMore ? (
                        <ul className="pagination pagination-sm mt-4 mb-4">
                          <li
                            className={`paginate_button page-item next${
                              props.enableNext ? "" : " disabled"
                            }`}
                          >
                            <a
                              href={() => false}
                              aria-controls="orders"
                              data-dt-idx="4"
                              tabIndex="0"
                              className="page-link"
                              onClick={props.onNextPage}
                            >
                              Load more
                            </a>
                          </li>
                        </ul>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default TabbedTable;
